<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active' : jobSearchStatusModal}" id="jobSearchStatus-modal-template" v-if="jobSearchStatusModal">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">구직상태 변경</div>
      </div>
      <div class="modal-body-container ht-full">
        <div class="text-box-section mt-40">
          현재 구직활동에 대한 자신의 상태를 설정해주세요.일자리 몽땅에서는 구직을 희망하시는 분들께 우선적으로 알맞은 일자리를 추천해드리고 있습니다.
        </div>
        <div class="border-line-box">
          <ul class="job-search-check">
            <li>
              <label class="radio-item"><input type="radio" name="job_seeking" id="seeking_yes" value="SEEKING" v-model="jobSearchStatus" title="구직 희망 중 선택"><span class="custom-radio"></span>구직 희망 중</label>
              <div class="box-type bg-primary type-left">
                <ul class="list-type-dot">
                  <li>“적극적으로 구직을 희망합니다!”</li>
                  <li>일자리 몽땅에서 제공하는 일자리 추천 정보를 수신합니다.</li>
                </ul>
              </div>
            </li>
            <li>
              <label class="radio-item"><input type="radio" name="job_seeking" id="seeking_no" value="NOT_SEEKING" v-model="jobSearchStatus" title="구직 의사 없음 선택"><span class="custom-radio"></span>구직 의사 없음</label>
              <div class="box-type bg-primary type-left">
                <ul class="list-type-dot">
                  <li>“현재 구직이 필요하지 않아요. 둘러만 볼게요.”</li>
                  <li>일자리 몽땅에서 제공하는 일자리 추천 정보를 수신하지 않습니다.</li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150" @click="close">
          취소하기
        </button>
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="save">
          저장하기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>
<script>
  import Axios from "axios";

  export default {
    name: 'jobSearchStatus-modal-template',
    props: ['jobSearchStatusModal', 'jobSearchStatus'],
    data() {
      return {
        changeCode: this.jobSearchStatus,
        preJobSearchStatus: this.jobSearchStatus,
      };
    },
    watch: {
      jobSearchStatus() {
        this.changeCode = this.jobSearchStatus;
      },
    },
    methods: {
      save() {
        // 변경사항이 없으면 저장하지 않음
        if (this.changeCode === this.preJobSearchStatus) {
          this.jobSearchStatusModal = false;
          $('body').removeClass('modal-open');
          return;
        }

        const params = {
          jobSearchStatus: this.changeCode
        };
        
        Axios.post(`/api/idb/updateJobSearchStatus`, params)
            .then((response) => {
              if (response.data.success === 'U') {
                alert('구직상태가 변경되었습니다.');
                
                // 저장 성공 시 이전 값도 업데이트 (취소 시 되돌릴 값)
                this.preJobSearchStatus = this.changeCode;
                
                // Props 직접 수정 제거, 부모 컴포넌트에 이벤트 전달
                this.$emit('update:jobSearchStatus', this.changeCode);
                this.jobSearchStatusModal = false;
                $('body').removeClass('modal-open');
              } else {
                alert('구직상태 변경에 실패했습니다.');
              }
            })
            .catch((error) => {
              console.error('구직상태 변경 실패:', error);
              alert('구직상태 변경 중 오류가 발생했습니다.');
            });
      },
      close() {
        this.$emit('update:jobSearchStatus', this.preJobSearchStatus);
        this.jobSearchStatusModal = false;
        $('body').removeClass('modal-open');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// JobSearchStatusModal.vue?9c4fea30